"use strict";
/* eslint @typescript-eslint/quotes: 0 */
/* eslint @typescript-eslint/comma-dangle: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.availableLanguages = void 0;
exports.availableLanguages = [
    "da",
    "en",
    "sv",
    "de",
    "pt",
    "no",
    "es",
    "fr"
];
exports.translations = {
    "$APP_NAME": {
        "da": "Mit Forløb®",
        "en": "My Treatment",
        "sv": "Min Behandling",
        "de": "Meine Behandlung",
        "pt": "Meu Tratamento",
        "no": "Min Behandling",
        "es": "Mi Tratamiento",
        "fr": "Mes Soins"
    },
    "accept": {
        "da": "Accepter",
        "en": "Accept",
        "sv": "Acceptera",
        "de": "Akzeptieren",
        "pt": "Aceitar",
        "no": "Aksepter",
        "es": "Aceptar",
        "fr": "Accepter"
    },
    "warning": {
        "da": "Advarsel",
        "en": "Warning",
        "sv": "Varning",
        "de": "Warnung",
        "pt": "Aviso",
        "no": "Advarsel",
        "es": "Advertencia",
        "fr": "Avertissement"
    },
    "error": {
        "da": "Fejl",
        "en": "Error",
        "sv": "Fel",
        "de": "Fehler",
        "pt": "Erro",
        "no": "Feil",
        "es": "Error",
        "fr": "Erreur"
    },
    "success": {
        "da": "Success",
        "en": "Success",
        "sv": "Framsteg",
        "de": "Erfolg",
        "pt": "Sucesso",
        "no": "Suksess",
        "es": "Éxito",
        "fr": "Succès"
    },
    "info": {
        "da": "Information",
        "en": "Information",
        "sv": "Information",
        "de": "Information",
        "pt": "Informação",
        "no": "Informasjon",
        "es": "Información",
        "fr": "Information"
    },
    "activity_minutes": {
        "da": "Aktivitet (min)",
        "en": "Activity (min)",
        "sv": "Aktivitet (min)",
        "de": "Aktivität (min)",
        "pt": "Atividade (min)",
        "no": "Aktivitet (min)",
        "es": "Actividad (minutos)",
        "fr": "Activité (min)"
    },
    "go_back": {
        "da": "Gå tilbage",
        "en": "Go back",
        "sv": "Gå tillbaka",
        "de": "Zurückkehren",
        "pt": "Retornar",
        "no": "Gå tilbake",
        "es": "Devolver",
        "fr": "Retour"
    },
    "all_videos": {
        "da": "Alle videoer",
        "en": "All videos",
        "sv": "Alla videor",
        "de": "Alle Videos",
        "pt": "Mostrar tudo",
        "no": "Alle videoer",
        "es": "Mostrar todo",
        "fr": "Afficher tout"
    },
    "biking": {
        "da": "Cykling",
        "en": "Biking",
        "sv": "Bläddra",
        "de": "Radfahren",
        "pt": "Ciclismo",
        "no": "Sykling",
        "es": "Bicicleta ",
        "fr": "Cyclisme"
    },
    "cancel": {
        "da": "Annuller",
        "en": "Cancel",
        "sv": "Avbryt",
        "de": "Stornieren",
        "pt": "Cancelar",
        "no": "Avbryt",
        "es": "Anular ",
        "fr": "Annuler"
    },
    "change": {
        "da": "Skift",
        "en": "Change",
        "sv": "Växla",
        "de": "Wechseln",
        "pt": "Mudar",
        "no": "Skift",
        "es": "Cambiar",
        "fr": "Changer"
    },
    "close": {
        "da": "Luk",
        "en": "Close",
        "sv": "Stäng",
        "de": "Schließen",
        "pt": "Fechar",
        "no": "Lukk",
        "es": "Cerrar",
        "fr": "Fermer"
    },
    "confirm_next": {
        "da": "Bekræft og Næste",
        "en": "Confirm and Next",
        "sv": "Bekräfta och Nästa",
        "de": "Bestätigen und Weiter",
        "pt": "Confirmar e ir para o próximo",
        "no": "Bekreft og neste",
        "es": "Confirmar y Siguiente",
        "fr": "Confirmer et Suivant"
    },
    "contact": {
        "da": "Kontakt",
        "en": "Contact",
        "sv": "Kontakta",
        "de": "Kontakt",
        "pt": "Contato",
        "no": "Kontakt",
        "es": "Contacto",
        "fr": "Contact"
    },
    "continue": {
        "da": "Fortsæt",
        "en": "Continue",
        "sv": "Fortsätt",
        "de": "Fortsetzen",
        "pt": "Continuar",
        "no": "Fortsett",
        "es": "Continuar ",
        "fr": "Continuer"
    },
    "course": {
        "da": "Forløbet",
        "en": "Course",
        "sv": "Processen",
        "de": "Behandlung",
        "pt": "Tratamento",
        "no": "Forløpet",
        "es": "Tratamiento",
        "fr": "Soins"
    },
    "or": {
        "da": "Eller",
        "en": "Or",
        "sv": "Eller",
        "de": "Oder",
        "pt": "ou",
        "no": "Eller",
        "es": "O",
        "fr": "Ou"
    },
    "danish": {
        "da": "Dansk",
        "en": "Danish",
        "sv": "Danska",
        "de": "Dänisch",
        "pt": "Dinamarquês",
        "no": "Dansk",
        "es": "Danés",
        "fr": "Danois"
    },
    "english": {
        "da": "Engelsk",
        "en": "English",
        "sv": "Engelska",
        "de": "Englisch",
        "pt": "Inglês",
        "no": "Engelsk",
        "es": "Inglés ",
        "fr": "Anglais"
    },
    "portuguese": {
        "da": "Portugisisk",
        "en": "Portuguese",
        "sv": "Portugisiska",
        "de": "Portugiesisch",
        "pt": "Português",
        "no": "Portugisisk",
        "es": "Portugués",
        "fr": "Portugais"
    },
    "norwegian": {
        "da": "Norsk",
        "en": "Norwegian",
        "sv": "Norska",
        "de": "Norwegisch",
        "pt": "Norueguês",
        "no": "Norsk",
        "es": "Noruego",
        "fr": "Norvégien"
    },
    "spanish": {
        "da": "Spansk",
        "en": "Spanish",
        "sv": "Spanska",
        "de": "Spanisch",
        "pt": "Espanhol",
        "no": "Spansk",
        "es": "Español",
        "fr": "Espagnol"
    },
    "data_policy": {
        "da": "Datapolitik",
        "en": "Privacy Policy",
        "sv": "Datapolicy",
        "de": "Datenpolitik",
        "pt": "Política de privacidade",
        "no": "Datapolicy",
        "es": "Política de protección de datos",
        "fr": "Politique de confidentialité"
    },
    "data_policy_body": {
        "da": "Ved brug af Mit Forløb® samler vi oplysninger om dit besøg ved hjælp af cookies for at måle hvordan Mit Forløb® bliver brugt, så vi kan udvikle indhold og funktioner. \\n\\nEventuelle data du indtaster, bliver gemt i anonymiseret form.",
        "en": "When you use My Treatment®, we use cookies to collect information about your session to assess how you and others use My Treatment® so that we can develop content and features. \\n\\nAny data you input will be saved anonymously.",
        "sv": "När du använder Min Behandling® samlar vi in information om ditt besök med hjälp av cookies för att mäta hur Min Behandling® används så att vi kan utveckla innehåll och funktioner. \\n\\nAlla uppgifter som du anger kommer att lagras i anonymiserad form.",
        "de": "Bei der Nutzung von Meine Behandlung sammeln wir mithilfe von Cookies Informationen über Ihren Besuch, um zu messen, wie Meine Behandlung genutzt wird, damit wir Inhalte und Funktionen entwickeln können. \\n\\nAlle von Ihnen eingegebenen Daten werden in anonymisierter Form gespeichert.",
        "pt": "Quando você usa o Meu Tratamento®, usamos cookies para coletar informações sobre a sua sessão e avaliar como você e outras pessoas usam o Meu Tratamento® para que possamos desenvolver conteúdo e recursos. \\n\\nQuaisquer dados inseridos serão salvos anonimamente.",
        "no": "Ved bruk av Min Behandling® samler vi inn opplysninger om ditt besøk ved hjelp av informasjonskapsler. Dette gjør vi for å måle hvordan Min Behandling® brukes, og dermed kunne utvikle innhold og funksjoner. \\n\\nEventuelle data du skriver inn vil bli lagret i anonymisert form.",
        "es": "Al iniciar Mi Tratamiento se crea un perfil con el nombre del usuario y la fecha de la operación. Esta información es necesaria para que Mi Tratamiento pueda ofrecer el servicio deseado. Como usuario de Mi Tratamiento también podrá añadir y guardar notas personales. Estas notas son para su uso personal durante el curso del tratamiento.\\n\\nLa información que decida anotar no recibirá ningún tipo de tratamiento y será eliminada automáticamente después de dejar de usar Mi Tratamiento.",
        "fr": "Lors de votre navigation sur Mes Soins®, nous utilisons des cookies pour recueillir des informations concernant votre session afin d'évaluer la façon dont vous et d'autres utilisateurs utilisent Mes Soins® nous permettant ainsi de développer notre contenu et nos fonctionnalités. \\n\\nToutes les données que vous saisissez sont sauvegardées de manière anonyme."
    },
    "data_policy_read_more": {
        "da": "Læs mere om vores generelle datapolitik her",
        "en": "Read more about our general privacy policy here",
        "sv": "Läs mer om vår allmänna datapolicy här",
        "de": "Lesen Sie hier mehr über unsere allgemeine Datenpolitik",
        "pt": "Leia mais sobre a nossa política de privacidade geral aqui",
        "no": "Les mer om vår generelle datapolicy her",
        "es": "Para más información sobre nuestra política de protección de dato, pulse aquí ",
        "fr": "Pour en savoir plus à propos de notre politique générale en matière de confidentialité, cliquez ici."
    },
    "date_examination": {
        "da": "Din undersøgelsesdato",
        "en": "Your exam date",
        "sv": "Datum för din undersökning",
        "de": "Ihr Untersuchungsdatum",
        "pt": "Data do seu exame",
        "no": "Din undersøkelsesdato",
        "es": "Fecha de examen médico",
        "fr": "La date de votre examen"
    },
    "date_operation": {
        "da": "Din operationsdato",
        "en": "Your operation date",
        "sv": "Datum för din operation",
        "de": "Ihr Operationsdatum",
        "pt": "Data da sua operação",
        "no": "Din operasjonsdato",
        "es": "Fecha de la intervención",
        "fr": "La date de votre opération"
    },
    "date_treatment": {
        "da": "Din behandlingsdato",
        "en": "Your treatment date",
        "sv": "Ditt behandlingsdatum",
        "de": "Ihr Behandlungsdatum",
        "pt": "Data do seu tratamento",
        "no": "Din behandlingsdato",
        "es": "Fecha del tratamiento",
        "fr": "La date de votre soin"
    },
    "edit": {
        "da": "Redigér",
        "en": "Edit",
        "sv": "Redigera",
        "de": "Bearbeiten",
        "pt": "Editar",
        "no": "Rediger",
        "es": "Editar",
        "fr": "Modifier"
    },
    "enter_personal_code": {
        "da": "Indtast din personlige kode",
        "en": "Input your personal code",
        "sv": "Ange din personliga kod",
        "de": "Geben Sie Ihren persönlichen Code ein",
        "pt": "Digite o seu código pessoal",
        "no": "Skriv inn din personlige kode",
        "es": "Introduzca su contraseña personal",
        "fr": "Saisissez votre code personnel"
    },
    "enter_valid_mail": {
        "da": "Mangler en gyldig e-mail adresse",
        "en": "A valid email address is required",
        "sv": "En giltig e-postadress saknas",
        "de": "Es fehlt eine gültige E-Mail-Adresse",
        "pt": "É necessário um endereço de e-mail válido",
        "no": "Mangler en gyldig e-postadresse",
        "es": "Introduzca por favor una dirección de correo electrónico válida",
        "fr": "Une adresse électronique valide est requise"
    },
    "exercise": {
        "da": "Træning",
        "en": "Exercise",
        "sv": "Motion",
        "de": "Training",
        "pt": "Exercício",
        "no": "Trening",
        "es": "Entrenamiento",
        "fr": "Exercice"
    },
    "exercise_add_entry": {
        "da": "Tilføj registrering",
        "en": "Add entry",
        "de": "Informationen hinzufügen",
        "pt": "Adicione registro",
        "no": "Legg til registrering",
        "es": "Agregar actividad",
        "fr": "Ajouter des données"
    },
    "exercise_entry_saved": {
        "da": "Din registrering er gemt",
        "en": "The entry was saved",
        "de": "Ihre Angaben wurden gespeichert.",
        "pt": "Registro salvo",
        "no": "Registreringen din er lagret ",
        "es": "La actividad ha sido guardada",
        "fr": "La saisie a été enregistrée"
    },
    "exercise_how_long": {
        "da": "Hvor længe varede træningen?",
        "en": "How long was your exercise?",
        "de": "Wie lange dauerte das Training?",
        "pt": "Quanto tempo durou o seu exercício?",
        "no": "Hvor lenge varte treningen?",
        "es": "Duración de la actividad",
        "fr": "Combien de temps a duré votre exercice ?"
    },
    "exercise_intro": {
        "da": "Tilføj registreringer og få overblik over dit genoptræningsforløb",
        "en": "Add entries and get an overview of your rehabilitation exercise",
        "de": "Fügen Sie Informationen hinzu und bekommen Sie einen Überblick über Ihren Rehabilitationsverlauf.",
        "pt": "Adicione registros e tenha uma visão geral do seu exercício de reabilitação",
        "no": "Legg til registreringer og få et overblikk over din opptrening. ",
        "es": "Añadir actividades y obtenga una vista general del proceso de rehabilitación",
        "fr": "Ajoutez des données et obtenez un aperçu de votre exercice de rééducation"
    },
    "exercise_mild_pain": {
        "da": "Milde smerter",
        "en": "Mild pain",
        "de": "Milde Schmerzen",
        "pt": "Dor suave",
        "no": "Mild smerte",
        "es": "Dolor leve",
        "fr": "Légère douleur"
    },
    "exercise_moderate_pain": {
        "da": "Moderate smerter",
        "en": "Moderate pain",
        "de": "Mäßige Schmerzen",
        "pt": "Dor moderada",
        "no": "Moderat smerte",
        "es": "Dolor moderado",
        "fr": "Douleur modérée"
    },
    "exercise_new_entry": {
        "da": "Ny registrering",
        "en": "New entry",
        "de": "Neue Informationen",
        "pt": "Novo registro",
        "no": "Ny registrering",
        "es": "Nueva actividad",
        "fr": "Nouvelles données"
    },
    "exercise_no_entries": {
        "da": "Ingen registrering",
        "en": "No entries",
        "de": "Keine Informationen",
        "pt": "Sem registros",
        "no": "Ingen registrering",
        "es": "No hay actividades registradas",
        "fr": "Aucune donnée"
    },
    "exercise_no_pain": {
        "da": "Ingen smerter",
        "en": "No pain",
        "de": "Keine Schmerzen",
        "pt": "Sem dor",
        "no": "Ingen smerte",
        "es": "Sin dolor",
        "fr": "Pas de douleur"
    },
    "exercise_servere_pain": {
        "da": "Voldsomme smerter",
        "en": "Severe pain",
        "de": "Starke Schmerzen",
        "pt": "Dor forte",
        "no": "Kraftige smerter",
        "es": "Dolor agudo",
        "fr": "Douleur intense"
    },
    "exercise_very_severe_pain": {
        "da": "Meget voldsomme smerter",
        "en": "Very severe pain",
        "de": "Sehr starke Schmerzen",
        "pt": "Dor muito forte",
        "no": "Voldsomme smerter",
        "es": "Dolor muy agudo",
        "fr": "Douleur très intense"
    },
    "exercise_what_to_enter": {
        "da": "Hvad ønsker du at registrere?",
        "en": "What would you like to enter?",
        "de": "Was möchten Sie registrieren?",
        "pt": "O que você gostaria de registrar?",
        "no": "Hva ønsker du å registrere?",
        "es": "¿Qué actividad desea registrar?",
        "fr": "Que souhaitez-vous saisir ?"
    },
    "exercise_worst_pain": {
        "da": "Værst tænkelige smerter",
        "en": "Worst pain imaginable",
        "de": "Schlimmster vorstellbarer Schmerz",
        "pt": "Pior dor imaginável",
        "no": "Verst tenkelige smerter",
        "es": "Dolor insoportable",
        "fr": "La pire douleur imaginable"
    },
    "exercises": {
        "da": "Øvelser",
        "en": "Exercises",
        "de": "Übungen",
        "pt": "Exercícios",
        "no": "Øvelser",
        "es": "Ejercicios",
        "fr": "Exercices"
    },
    "faq": {
        "da": "Spørgsmål",
        "en": "Questions",
        "sv": "Frågor",
        "de": "Fragen",
        "pt": "Perguntas",
        "no": "Spørsmål",
        "es": "Preguntas",
        "fr": "Questions"
    },
    "faqs": {
        "da": "Oftest stillede spørgsmål",
        "en": "Frequently asked questions",
        "sv": "Vanliga frågor och svar",
        "de": "Häufig gestellte Fragen",
        "pt": "Perguntas frequentes",
        "no": "Ofte stilte spørsmål",
        "es": "Preguntas frecuentes",
        "fr": "Questions fréquemment posées"
    },
    "favorites": {
        "da": "Se gemte",
        "en": "See hidden",
        "sv": "Se dolda",
        "de": "Siehe gespeicherte",
        "pt": "Ver oculto",
        "no": "Se lagrede",
        "es": "Mis favoritos",
        "fr": "Affichez les éléments cachés"
    },
    "german": {
        "da": "Tysk",
        "en": "German",
        "sv": "Tyska",
        "de": "Deutsch",
        "pt": "Alemão",
        "no": "Tysk",
        "es": "Alemán",
        "fr": "Allemand"
    },
    "french": {
        "da": "Fransk",
        "en": "French",
        "sv": "Franska",
        "de": "Französisch",
        "pt": "Francês",
        "no": "Fransk",
        "es": "Francés",
        "fr": "Français"
    },
    "guides": {
        "da": "Vejledninger",
        "en": "Guides",
        "sv": "Vägledning",
        "de": "Anleitungen",
        "pt": "Guias",
        "no": "Veiledninger",
        "es": "Guías",
        "fr": "Manuels"
    },
    "help": {
        "da": "Hjælp",
        "en": "Help",
        "sv": "Hjälp",
        "de": "Hilfe",
        "pt": "Ajuda",
        "no": "Hjelp",
        "es": "Aider",
        "fr": "Aide"
    },
    "loading_dotdotdot": {
        "da": "Henter...",
        "en": "Loading...",
        "sv": "Hämtar...",
        "de": "Wird geladen...",
        "pt": "Carregando...",
        "no": "Henter...",
        "es": "Abriendo...",
        "fr": "Chargement..."
    },
    "log_out": {
        "da": "Log ud",
        "en": "Log out",
        "sv": "Logga ut",
        "de": "Ausloggen",
        "pt": "Terminar sessão",
        "no": "Logg ut",
        "es": "Desconectar",
        "fr": "Déconnexion"
    },
    "login_error_code_expired": {
        "da": "Koden er udløbet",
        "en": "Code expired",
        "sv": "Koden har upphört att gälla",
        "de": "Der Code ist abgelaufen",
        "pt": "Código expirado",
        "no": "Koden er utløpt",
        "es": "Contraseña caducada",
        "fr": "Code expiré"
    },
    "login_error_code_invalid": {
        "da": "Ugyldig kode",
        "en": "Invalid code",
        "sv": "Ogiltig kod",
        "de": "Ungültiger Code",
        "pt": "Código inválido",
        "no": "Ugyldig kode",
        "fr": "Code invalide"
    },
    "login_error_code_not_found": {
        "da": "Koden findes ikke.\\nTjek at den er indtastet korrekt, eller kontakt dit behandlingssted.",
        "en": "That code does not exist.\\nMake sure you input the code correctly, or contact your treatment facility.",
        "sv": "Koden finns inte.\\nKontrollera att den har angetts korrekt eller kontakta din vårdgivare.",
        "de": "Der Code ist nicht vorhanden.\\nÜberprüfen Sie die korrekte Eingabe oder wenden Sie sich an Ihre Behandlungseinrichtung.",
        "pt": "Esse código não existe.\\nCertifique-se de inserir o código corretamente ou entre em contato com a instituição de tratamento.",
        "no": "Koden finnes ikke.\\nSjekk at den er skrevet inn riktig, eller kontakt behandlingsstedet ditt.",
        "es": "El código no existe.\\nComprueba que se ha introducido correctamente o contacta con tu centro de tratamiento.",
        "fr": "Ce code n'existe pas.\\nVérifiez d'avoir correctement saisi le code ou contactez votre centre de soins."
    },
    "login_error_network_error": {
        "da": "Ingen internet forbindelse",
        "en": "No internet connection",
        "sv": "Ingen internetanslutning",
        "de": "Keine Internetverbindung",
        "pt": "Sem conexão à Internet",
        "no": "Ingen internettforbindelse",
        "es": "Sin conexión a Internet",
        "fr": "Aucune connexion internet"
    },
    "login_error_password_missing": {
        "da": "Indtast venligst adgangskode",
        "en": "Please input password",
        "sv": "Ange lösenord",
        "de": "Bitte passwort eingeben",
        "pt": "Insira o código de acesso",
        "no": "Skriv inn passord",
        "es": "Introduzca contraseña",
        "fr": "Veuillez saisir le code d'accès"
    },
    "login_error_username_missing": {
        "da": "Indtast venligst e-mail",
        "en": "Please input email address",
        "sv": "Ange e-postadress",
        "de": "Bitte E-Mail-Adresse eingeben",
        "pt": "Insira o endereço de e-mail",
        "no": "Skriv inn e-postadresse",
        "es": "Introduzca correo electrónico",
        "fr": "Veuillez saisir l'adresse électronique"
    },
    "login_error_username_password_mismatch": {
        "da": "Indtastet email/password var ikke korrekt",
        "en": "Incorrect email address or password",
        "sv": "Angiven e-postadress/lösenord var inte korrekt",
        "de": "Die eingegebene E-Mail-Adresse/das eingegebene Passwort war falsch",
        "pt": "Endereço de e-mail ou senha incorretos",
        "no": "E-postadressen/passordet du skrev inn var feil",
        "es": "Correo electrónico/contraseña incorrecto ",
        "fr": "Adresse électronique ou mot de passe incorrect"
    },
    "login_error_too_few_characters": {
        "da": "Koden mangler én eller flere karakterer.\\nIndtast hele din personlige kode, og prøv igen.",
        "en": "One or more characters are missing from the code.\\nInput your entire personal code and try again.",
        "sv": "Koden saknar ett eller flera tecken.\\nAnge hela din personliga kod och försök igen.",
        "de": "Dem Code fehlen ein oder mehrere Zeichen.\\nGeben Sie Ihren gesamten persönlichen Code ein und versuchen Sie es erneut.",
        "pt": "Um ou mais caracteres estão faltando no código.\\nInsira o seu código pessoal completo e tente novamente.",
        "no": "Koden mangler ett eller flere tegn.\\nSkriv inn hele din personlige kode og prøv igjen.",
        "es": "Al código le faltan uno o más caracteres.\\nIntroduce tu código personal completo e inténtalo de nuevo.",
        "fr": "Un ou plusieurs caractères manquent dans le code.\\nSaisissez l'intégralité de votre code personnel et réessayez."
    },
    "merge_error_code_already_used": {
        "da": "Koden har tidligere været taget i brug og kan derfor ikke tilføjes",
        "en": "This code cannot be added because it has already been used",
        "sv": "Koden har använts tidigare och kan därför inte läggas till",
        "de": "Der Code wurde bereits verwendet und kann daher nicht hinzugefügt werden",
        "pt": "Esse código não pode ser adicionado porque já foi usado",
        "no": "Koden har vært i bruk tidligere og kan derfor ikke legges til",
        "es": "La contraseña ha estado en uso anteriormente y no puede utilizarse",
        "fr": "Ce code ne peut pas être ajouté puisqu'il a déjà été utilisé"
    },
    "merge_error_code_parameter_missing": {
        "da": "Indtast venligst en kode",
        "en": "Please input a code",
        "sv": "Ange en kod",
        "de": "Bitte geben Sie einen Code ein",
        "pt": "Insira um código",
        "no": "Skriv inn en kode",
        "es": "Por favor, introduzca contraseña",
        "fr": "Veuillez saisir un code"
    },
    "merge_error_current_user_not_found": {
        "da": "Fejl med nuværende kode",
        "en": "Unexpected error with current user",
        "sv": "Fel med nuvarande kod",
        "de": "Unerwarteter Fehler beim aktuellen Code",
        "pt": "Erro de código atual",
        "no": "Feil med nåværende kode",
        "es": "Error de contraseña activada ",
        "fr": "Erreur du code actuel"
    },
    "merge_error_prefix": {
        "da": "Fejl",
        "en": "Error",
        "sv": "Fel",
        "de": "Fehler",
        "pt": "Erro",
        "no": "Feil",
        "es": "Error   ",
        "fr": "Erreur"
    },
    "merge_error_same_code": {
        "da": "Den indtastede kode er allerede aktiv",
        "en": "The code you input is already active",
        "sv": "Den angivna koden är redan aktiv",
        "de": "Der eingegebene Code ist bereits aktiv",
        "pt": "O código introduzido já está ativo",
        "no": "Den angitte koden er allerede aktiv",
        "es": "La contraseña introducida ya está en uso",
        "fr": "Le code saisi est déjà actif"
    },
    "merge_error_unknown_code": {
        "da": "Ukendt kode",
        "en": "Unknown code",
        "sv": "Okänd kod",
        "de": "Unbekannter Code",
        "pt": "Código desconhecido",
        "no": "Ukjent kode",
        "es": "Contraseña desconocida",
        "fr": "Code inconnu"
    },
    "merge_error_unknown_error": {
        "da": "Der skete en uventet fejl. Prøv igen senere.",
        "en": "An unexpected error occurred. Try again later.",
        "sv": "Ett oväntat fel inträffade. Vänligen försök igen senare.",
        "de": "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es später erneut.",
        "pt": "Ocorreu um erro desconhecido. Tente novamente mais tarde.",
        "no": "En uventet feil oppstod. Prøv igjen senere.",
        "es": "Error desconocido. Vuelva a intentar más tarde.",
        "fr": "Une erreur inconnue s'est produite. Réessayez plus tard."
    },
    "merge_error_user_not_logged_in": {
        "da": "Log venligst ind igen",
        "en": "Please log in again",
        "sv": "Logga in igen",
        "de": "Bitte melden Sie sich erneut an",
        "pt": "Faça login novamente",
        "no": "Logg inn igjen",
        "es": "Por favor, intente conectarse de nuevo",
        "fr": "Veuillez vous reconnecter"
    },
    "merge_error_new_language": {},
    "new_language_missing_translation_title": {
        "da": "Manglende oversættelse",
        "en": "Translation missing",
        "sv": "Översättning saknas",
        "de": "Fehlende Übersetzung",
        "pt": "Sem tradução",
        "no": "Manglende oversettelse",
        "es": "Traducción faltante",
        "fr": "Traduction manquante"
    },
    "new_language_missing_translation_body": {
        "da": "Modulet du er ved at tilgå findes desværre ikke på $LANGUAGE.",
        "en": "Unfortunately, the module you are about to open is not available in $LANGUAGE.",
        "sv": "Tyvärr finns inte den modul du söker tyvärr inte tillgänglig på $LANGUAGE.",
        "de": "Leider wurde das Modul, auf das Sie zugreifen, nicht auf $LANGUAGE gefunden.",
        "pt": "Infelizmente, o módulo que você está prestes a abrir não está disponível em $LANGUAGE.",
        "no": "Dessverre finnes ikke modulen du har tilgang til på $LANGUAGE.",
        "es": "Desafortunadamente, el curso al que está accediendo no está disponible en $LANGUAGE.",
        "fr": "Malheureusement, le module que vous êtes sur le point d'ouvrir n'est pas disponible en $LANGUAGE."
    },
    "new_language_missing_translation_body2": {
        "da": "Hvilket sprog ønsker du i stedet at se modulet på?",
        "en": "Which language would you like to view the module in instead?",
        "sv": "På vilket språk skulle du vilja se modulen istället?",
        "de": "In welcher Sprache möchten Sie das Modul stattdessen ansehen?",
        "pt": "Em qual idioma você gostaria de visualizar o módulo?",
        "no": "På hvilket språk ønsker du i stedet å se modulen?",
        "es": "¿En qué idioma quieres ver el curso?",
        "fr": "Dans quelle langue souhaitez-vous plutôt consulter le module ?"
    },
    "min": {
        "da": "min",
        "en": "min",
        "sv": "min",
        "de": "min",
        "pt": "min",
        "no": "min",
        "es": "min",
        "fr": "min"
    },
    "minutes": {
        "da": "Minutter",
        "en": "Minutes",
        "sv": "Minuter",
        "de": "Minuten",
        "pt": "Minutes",
        "no": "Minutter",
        "es": "Minutos",
        "fr": "Minutes"
    },
    "my_treatment_name": {
        "da": "Mit Forløb",
        "en": "My Treatment",
        "sv": "Min Behandling",
        "de": "Meine Behandlung",
        "pt": "Meu Tratamento",
        "no": "Min Behandling",
        "es": "Mi Tratamiento",
        "fr": "Mes Soins"
    },
    "next": {
        "da": "Næste",
        "en": "Next",
        "sv": "Nästa",
        "de": "Nächster",
        "pt": "Próximo",
        "no": "Neste",
        "es": "Siguiente",
        "fr": "Suivant"
    },
    "no_videos_in_category": {
        "da": "Der er ingen videoer i denne kategori",
        "en": "There are no videos in this category",
        "sv": "Det finns inga videor i denna kategori",
        "de": "In dieser Kategorie gibt es keine Videos",
        "pt": "Não existem vídeos nesta categoria",
        "no": "Det er ingen videoer i denne kategorien",
        "es": "No hay videos para esta categoría",
        "fr": "Il n'y a pas de vidéos dans cette catégorie"
    },
    "notifications": {
        "da": "Påmindelser",
        "en": "Notifications",
        "sv": "Påminnelser",
        "de": "Erinnerungen",
        "pt": "Notificações",
        "no": "Påminnelser",
        "es": "Notificaciones",
        "fr": "Notifications"
    },
    "notifications_blocked": {
        "da": "Du har blokeret påmindelser fra denne app",
        "en": "You have disabled notifications from this app",
        "sv": "Du har blockerat påminnelser från denna app",
        "de": "Sie haben Erinnerungen von dieser App blockiert",
        "pt": "Você desativou as notificações deste aplicativo",
        "no": "Du har blokkert påminnelser fra denne appen",
        "es": "Las notificaciones han sido desactivadas para esta aplicación",
        "fr": "Vous avez désactivé les notifications de cette application"
    },
    "notifications_get_reminders": {
        "da": "Få påmindelser om vigtige tidspunkter i forløbet",
        "en": "Get notifications about important dates and times",
        "sv": "Få påminnelser vid viktiga tidpunkter i processen",
        "de": "Erhalten Sie Erinnerungen zu wichtigen Zeitpunkten in der Behandlung",
        "pt": "Receba notificações sobre datas e horários importantes do tratamento",
        "no": "Få påminnelser om viktige tidspunkter i prosessen",
        "es": "Reciba notificaciones sobre momentos importantes durante el tratamiento",
        "fr": "Recevez des notifications sur les dates et les heures des soins importants"
    },
    "open_settings": {
        "da": "Åben indstillinger",
        "en": "Open settings",
        "sv": "Öppna inställningar",
        "de": "Einstellungen öffnen",
        "pt": "Abrir configurações",
        "no": "Åpne innstillinger",
        "es": "Abrir configuración",
        "fr": "Ouvrir les paramètres"
    },
    "overview": {
        "da": "Overblik",
        "en": "Overview",
        "sv": "Översikt",
        "de": "Überblick",
        "pt": "Visão geral",
        "no": "Oversikt",
        "es": "Vista general",
        "fr": "Aperçu"
    },
    "pain": {
        "da": "Smerter",
        "en": "Pain",
        "de": "Schmerzen",
        "pt": "Dor",
        "no": "Smerter ",
        "es": "Dolor",
        "fr": "Douleur"
    },
    "pain_0_10": {
        "da": "Smerter (0-10)",
        "en": "Pain (0-10)",
        "de": "Schmerzen (0-10)",
        "pt": "Dor (0 a 10)",
        "no": "Smerter (0-10) ",
        "es": "Dolor (0-10)",
        "fr": "Douleur (0-10)"
    },
    "pain_accessment": {
        "da": "Smertescore",
        "en": "Pain assessment",
        "de": "Schmerzskala",
        "pt": "Avaliação da dor",
        "no": "Smertescore",
        "es": "Balance de dolor",
        "fr": "Évaluation de la douleur"
    },
    "pain_after": {
        "da": "Dine smerter EFTER træning",
        "en": "Your pain AFTER exercise",
        "de": "Ihre Schmerzen nach den Übungen",
        "pt": "Sua dor DEPOIS do exercício",
        "no": "Smertene dine ETTER trening ",
        "es": "Dolor DESPUÉS de la actividad",
        "fr": "Votre douleur APRÈS l’exercice"
    },
    "pain_before": {
        "da": "Dine smerter FØR træning",
        "en": "Your pain BEFORE exercise",
        "de": "Ihre Schmerzen vor den Übungen",
        "pt": "Sua dor ANTES do exercício",
        "no": "Smertene dine FØR trening ",
        "es": "Dolor ANTES de la actividad",
        "fr": "Votre douleur AVANT l’exercice"
    },
    "pamphlets": {
        "da": "Pjecer",
        "en": "Pamphlets",
        "sv": "Broschyrer",
        "de": "Broschüren",
        "pt": "Livretos",
        "no": "Pamfletter",
        "es": "Folletos",
        "fr": "Livrets"
    },
    "patient_information": {
        "da": "Patientinformation",
        "en": "Patient information",
        "sv": "Patientinformation",
        "de": "Patienteninformation",
        "pt": "Informações do paciente",
        "no": "Pasientinformasjon",
        "es": "Información al paciente",
        "fr": "Informations relatives au patient"
    },
    "please_wait": {
        "da": "Vent et øjeblik",
        "en": "One moment, please",
        "sv": "Vänta ett ögonblick",
        "de": "Warten Sie einen Moment",
        "pt": "Um momento, por favor",
        "no": "Vent et øyeblikk",
        "es": "Espere",
        "fr": "Un instant, s'il vous plaît"
    },
    "preparing_content": {
        "da": "Opsætter dit modul",
        "en": "Setting up your module",
        "sv": "Konfigurerar din modul",
        "de": "Einrichten Ihres Moduls",
        "pt": "Configuração de seu módulo",
        "no": "Setter opp modulen din",
        "es": "Preparando su plan de tratamiento",
        "fr": "Préparation du module"
    },
    "print_document": {
        "da": "Udskriv pjece",
        "en": "Print pamphlet",
        "sv": "Skriv ut broschyr",
        "de": "Broschüre drucken",
        "pt": "Imprimir livreto",
        "no": "Skriv ut pamflett",
        "es": "Imprimir folleto",
        "fr": "Imprimer le livret"
    },
    "read_more_about_your_treatment": {
        "da": "Her kan du læse mere om dit forløb.",
        "en": "You can read more about your treatment here.",
        "sv": "Läs mer om din process här.",
        "de": "Hier können Sie mehr über Ihre Behandlung lesen.",
        "pt": "Você pode ler mais sobre seu tratamento aqui.",
        "no": "Her kan du lese mer om forløpet ditt.",
        "es": "Consulte aquí más información sobre su tratamiento. ",
        "fr": "Pour en savoir plus à propos de vos soins, cliquez ici."
    },
    "save": {
        "da": "Gem",
        "en": "Save",
        "sv": "Spara",
        "de": "Speichern",
        "pt": "Salvar",
        "no": "Lagre",
        "es": "Guardar",
        "fr": "Sauvegarder"
    },
    "set_date": {
        "da": "Tilføj operationsdato",
        "en": "Add operation date",
        "sv": "Lägg till datum för operation",
        "de": "Operationsdatum hinzufügen",
        "pt": "Adicionar data da operação",
        "no": "Legg til operasjonsdato",
        "es": "Agregar fecha de la intervención quirúrgica",
        "fr": "Ajouter une date d'opération"
    },
    "set_date_examination": {
        "da": "Tilføj undersøgelsesdato",
        "en": "Add examination date",
        "sv": "Lägg till undersökningsdatum",
        "de": "Untersuchungsdatum hinzufügen",
        "pt": "Adicionar data do exame",
        "no": "Legg til undersøkelsesdato",
        "es": "Agregar fecha de examen médico",
        "fr": "Ajouter une date d'examen"
    },
    "set_date_operation": {
        "da": "Tilføj operationsdato",
        "en": "Add operation date",
        "sv": "Lägg till datum för operation",
        "de": "Operationsdatum hinzufügen",
        "pt": "Adicionar data da operação",
        "no": "Legg til operasjonsdato",
        "es": "Agregar fecha de la intervención quirúrgica",
        "fr": "Ajouter une date d'opération"
    },
    "set_date_treatment": {
        "da": "Tilføj behandlingsdato",
        "en": "Add treatment date",
        "sv": "Lägg till behandlingsdatum",
        "de": "Behandlungsdatum hinzufügen",
        "pt": "Adicionar data do tratamento",
        "no": "Legg til behandlingsdato",
        "es": "Agregar fecha del tratamiento",
        "fr": "Ajouter une date de soins"
    },
    "share": {
        "da": "Del",
        "en": "Share",
        "sv": "Dela",
        "de": "Teilen",
        "pt": "Compartilhar",
        "no": "Del",
        "es": "Compartir",
        "fr": "Partager"
    },
    "share_allow_friends_and_family": {
        "da": "Giv dine pårørende og venner adgang til modulet.",
        "en": "Give friends and family access to this module.",
        "sv": "Ge dina släktingar och vänner åtkomst till modulen.",
        "de": "Geben Sie Ihren Angehörigen und Freunden Zugang zum Modul.",
        "pt": "Dê a amigos e familiares acesso a este módulo.",
        "no": "Gi dine pårørende og venner tilgang til modulen.",
        "es": "Permita que familiares y amigos sigan su tratamiento",
        "fr": "Permettez à vos amis et à votre famille d'accéder à ce module."
    },
    "share_body_patient": {
        "da": "Dette vil give dine pårørende adgang til modulets film og skriftlige information.",
        "en": "This will allow your loved ones to access the videos and written information in this module.",
        "sv": "Detta ger dina anhöriga åtkomst till film om modulen och skriftlig information.",
        "de": "Dadurch erhalten Ihre Angehörigen Zugriff auf den Film und die schriftlichen Informationen des Moduls.",
        "pt": "Isso permitirá que seus entes queridos acessem os vídeos e as informações escritas neste módulo.",
        "no": "Dette vil gi dine pårørende tilgang til modulens film og skriftlige informasjon.",
        "es": "Aquí puede autorizar que sus familiares tengan acceso a los videos y a la información escrita de Mi Tratamiento.",
        "fr": "Cela permettra à vos proches d'accéder aux vidéos et aux informations écrites de ce module."
    },
    "share_error_add_name": {
        "da": "Tilføj dit navn som afsender",
        "en": "Add your name as the sender",
        "sv": "Lägg till ditt namn som avsändare",
        "de": "Fügen Sie Ihren Namen als Absender hinzu",
        "pt": "Adicione seu nome como remetente",
        "no": "Legg til navnet ditt som avsender",
        "es": "Añadir nombre de remitente",
        "fr": "Ajoutez votre nom en tant qu'expéditeur"
    },
    "share_header_patient": {
        "da": "Del Mit Forløb med pårørende",
        "en": "Share My Treatment with loved ones",
        "sv": "Dela Min Behandling med anhöriga",
        "de": "Meine Behandlung mit Angehörigen teilen",
        "pt": "Compartilhar Meu Tratamento com os seus entes queridos",
        "no": "Del Min Behandling med pårørende",
        "es": "Compartir Mi Tratamiento con familiares",
        "fr": "Partagez Mes Soins avec mes proches"
    },
    "share_invitation_sent": {
        "da": "Modulet er blevet sendt afsted",
        "en": "The module has been sent",
        "sv": "Modulen har skickats",
        "de": "Das Modul wurde versendet",
        "pt": "O módulo foi enviado",
        "no": "Modulen er sendt",
        "es": "La invitación ha sido enviada",
        "fr": "Le module a été envoyé"
    },
    "share_no_personal_info": {
        "da": "Du deler ikke personlige oplysninger.",
        "en": "None of your personal information will be shared.",
        "sv": "Du delar inga personliga uppgifter.",
        "de": "Sie teilen keine persönlichen Daten.",
        "pt": "Nenhuma das suas informações pessoais será compartilhada.",
        "no": "Du deler ikke personopplysninger.",
        "es": "No se compartirán las informaciones y notas personales.",
        "fr": "Aucune de vos informations personnelles ne sera partagée."
    },
    "share_program_title": {
        "da": "Del Mit Forløb",
        "en": "Share My Treatment",
        "sv": "Dela Min Behandling",
        "de": "Meine Behandlung teilen",
        "pt": "Compartilhar Meu Tratamento",
        "no": "Del Min Behandling",
        "es": "Compartir Mi Tratamiento ",
        "fr": "Partager Mes Soins"
    },
    "share_receivers_mail": {
        "da": "Modtagers e-mail",
        "en": "Recipient's email address",
        "sv": "Mottagarens e-postadress",
        "de": "E-Mail des Empfängers",
        "pt": "Endereço de e-mail do destinatário",
        "no": "Mottakers e-post",
        "es": "Correo electrónico destinatario",
        "fr": "Adresse électronique du destinataire"
    },
    "show_more": {
        "da": "Se mere",
        "en": "See more",
        "sv": "Se mer",
        "de": "Mehr sehen",
        "pt": "Ver mais",
        "no": "Se mer",
        "es": "Mostrar más",
        "fr": "Voir plus d'informations"
    },
    "show_tendency_for": {
        "da": "Vis tendens for",
        "en": "Show tendency for",
        "de": "Entwicklungen anzeigen",
        "pt": "Mostrar tendência para/de/em",
        "no": "Vis en tendens for ",
        "es": "Mostrar tendencia de",
        "fr": "Afficher la tendance pour"
    },
    "staff_login": {
        "da": "Log in",
        "en": "Log in",
        "sv": "Logga in",
        "de": "Anmelden",
        "pt": "Iniciar sessão",
        "no": "Logg inn",
        "fr": "Se connecter"
    },
    "staff_login_always_show": {
        "da": "Vis automatisk personalelogin",
        "en": "Automatically show staff login",
        "sv": "Visa automatisk personalinloggning",
        "de": "Automatisches Personal-Login anzeigen",
        "pt": "Mostrar automaticamente o login do provedor",
        "no": "Vis automatisk personalinnlogging",
        "es": "Mostrar automáticamente inicio de sesión para personal",
        "fr": "Afficher automatiquement la session du fournisseur"
    },
    "staff_login_description": {
        "da": "Hvis du har fået tildelt et login til Mit Forløb af din afdeling, så kan du logge ind nedenfor",
        "en": "If your organization has given you a My Treatment login, you can log in below",
        "sv": "Om du har tilldelats en inloggning till Min Behandling av din avdelning kan du logga in nedan",
        "de": "Wenn Ihnen von Ihrer Abteilung ein Login für Meine Behandlung zugewiesen wurde, können Sie sich unten anmelden",
        "pt": "Se o seu estabelecimento lhe forneceu um login do Meu Tratamento, você pode fazer o login abaixo",
        "no": "Hvis du har fått tildelt innlogging til Min Behandling av avdelingen din, kan du logge inn nedenfor",
        "es": "Puede iniciar sesión abajo si ya le ha sido facilitada una contraseña para Mi Tratamiento.",
        "fr": "Si votre établissement vous a fourni un identifiant « Mes Soins », vous pouvez vous connecter ci-dessous"
    },
    "staff_login_error_invalid_email": {
        "da": "Ugyldig e-mail-adresse",
        "en": "Invalid email address",
        "sv": "Ogiltig e-postadress",
        "de": "Ungültige E-Mail-Adresse",
        "pt": "Endereço de e-mail inválido",
        "no": "Ugyldig e-postadresse",
        "es": "Correo electrónico no válido",
        "fr": "Adresse électronique invalide"
    },
    "staff_login_error_missing_code": {
        "da": "Indtast venligst adgangskode",
        "en": "Please input password",
        "sv": "Ange lösenord",
        "de": "Bitte Passwort eingeben",
        "pt": "Insira o código de acesso",
        "no": "Skriv inn passord",
        "es": "Por favor, introduzca contraseña",
        "fr": "Veuillez saisir le code d'accès"
    },
    "staff_login_link": {
        "da": "Log in som personale",
        "en": "Log in as staff",
        "sv": "Logga in som personal",
        "de": "Als Personal anmelden",
        "pt": "Iniciar sessão como provedor",
        "no": "Logg inn som personale",
        "es": "Iniciar sesión como personal",
        "fr": "Se connecter en tant que fournisseur"
    },
    "staff_login_mail": {
        "da": "Brugernavn / E-mail",
        "en": "Username / email address",
        "sv": "Användarnamn / E-post",
        "de": "Benutzername / E-Mail",
        "pt": "Nome de usuário / endereço de e-mail",
        "no": "Brukernavn / E-post",
        "es": "Correo electrónico",
        "fr": "Nom d'utilisateur / adresse électronique"
    },
    "staff_login_password": {
        "da": "Kodeord",
        "en": "Password",
        "sv": "Lösenord",
        "de": "Passwort",
        "pt": "Senha",
        "no": "Passord",
        "es": "Contraseña",
        "fr": "Mot de passe"
    },
    "staff_login_screen_name": {
        "da": "Personalelogin",
        "en": "Staff login",
        "sv": "Personalinloggning",
        "de": "Personal-Login",
        "pt": "Início de sessão de provedor",
        "no": "Personalinnlogging",
        "es": "Portal del empleado",
        "fr": "Session du fournisseur"
    },
    "swedish": {
        "da": "Svensk",
        "en": "Swedish",
        "sv": "Svenska",
        "de": "Schwedisch",
        "pt": "Sueco",
        "no": "Svensk",
        "es": "Sueco",
        "fr": "Suédois"
    },
    "switzerland": {
        "da": "Schweiz",
        "en": "Switzerland",
        "sv": "Schweiz",
        "de": "Schweiz",
        "pt": "Suíça",
        "no": "Sveits",
        "es": "Suiza",
        "fr": "Suisse"
    },
    "symptoms": {
        "da": "Symptomer",
        "en": "Symptoms",
        "sv": "Symtom",
        "de": "Symptome",
        "pt": "Sintomas",
        "no": "Symptomer",
        "es": "Síntomas",
        "fr": "Symptômes"
    },
    "system_language": {
        "da": "Systemsprog",
        "en": "System language",
        "sv": "Systemspråk",
        "de": "Systemsprache",
        "pt": "Idioma do sistema",
        "no": "Systemspråk",
        "es": "Idioma del sistema",
        "fr": "Langue du système"
    },
    "table_of_content": {
        "da": "Indholdsfortegnelse",
        "en": "Table of contents",
        "sv": "Innehållsförteckning",
        "de": "Inhaltsverzeichnis",
        "pt": "Índice",
        "no": "Innholdsfortegnelse",
        "es": "Contenido",
        "fr": "Table des matières"
    },
    "time": {
        "da": "Tid",
        "en": "Time",
        "sv": "Tid",
        "de": "Zeit",
        "pt": "Tempo",
        "no": "Tid",
        "es": "Hora",
        "fr": "Heure"
    },
    "today": {
        "da": "I dag",
        "en": "Today",
        "sv": "I dag",
        "de": "Heute",
        "pt": "Hoje",
        "no": "I dag",
        "es": "Hoy",
        "fr": "Aujourd’hui"
    },
    "walk": {
        "da": "Gang",
        "en": "Walk",
        "sv": "Spara",
        "de": "Gehen",
        "pt": "Caminhar",
        "no": "Gå",
        "es": "Andar ",
        "fr": "Marche"
    },
    "welcome": {
        "da": "Velkommen!",
        "en": "Welcome!",
        "sv": "Välkommen!",
        "de": "Willkommen!",
        "pt": "Bem-vindo!",
        "no": "Velkommen!",
        "es": "¡Bienvenido/a!",
        "fr": "Bienvenue !"
    },
    "welcome_text": {
        "da": "Velkommen til Mit Forløb!",
        "en": "Welcome to My Treatment!",
        "sv": "Välkommen till Min Behandling!",
        "de": "Willkommen zu Meine Behandlung!",
        "pt": "Bem-vindo ao Meu Tratamento!",
        "no": "Velkommen til Min Behandling!",
        "es": "Bienvenido/a a Mi Tratamiento",
        "fr": "Bienvenue sur Mes Soins !"
    },
    "when_is_your_examination": {
        "da": "Hvornår skal du undersøges?",
        "en": "When is your examination?",
        "sv": "När ska du undersökas?",
        "de": "Wann werden Sie untersucht?",
        "pt": "Quando é seu exame?",
        "no": "Når skal du undersøkes?",
        "es": "¿Cuándo tiene lugar el examen médico?",
        "fr": "Quelle est la date de votre examen ?"
    },
    "when_is_your_operation": {
        "da": "Hvornår skal du opereres?",
        "en": "When is your operation?",
        "sv": "När ska du opereras?",
        "de": "Wann werden Sie operiert?",
        "pt": "Quando é sua operação?",
        "no": "Når skal du opereres?",
        "es": "¿Cuándo se opera?",
        "fr": "Quelle est la date de votre opération ?"
    },
    "when_is_your_treatment": {
        "da": "Hvornår skal du behandles?",
        "en": "When is your treatment?",
        "sv": "När ska du behandlas?",
        "de": "Wann werden Sie behandelt?",
        "pt": "Quando é seu tratamento?",
        "no": "Når skal du behandles?",
        "es": "¿Cuándo empieza su tratamiento?",
        "fr": "Quelle est la date de vos soins ?"
    },
    "your_name": {
        "da": "Dit navn",
        "en": "Your name",
        "sv": "Ditt namn",
        "de": "Ihr Name",
        "pt": "Seu nome",
        "no": "Ditt navn",
        "es": "Su nombre",
        "fr": "Votre nom"
    },
    "survey_header": {
        "da": "Spørgeskema",
        "en": "Questionnaire",
        "sv": "Frågeformulär",
        "de": "Fragebogen",
        "pt": "Questionário",
        "no": "Spørreskjema",
        "es": "Cuestionario",
        "fr": "Questionnaire"
    },
    "previous": {
        "da": "Forrige",
        "en": "Previous",
        "sv": "Föregående",
        "de": "Vorherige",
        "pt": "Anterior",
        "no": "Forrige",
        "es": "Atrás",
        "fr": "Précédent"
    },
    "thanks_for_your_reply": {
        "da": "Tak for din besvarelse",
        "en": "Thank you for your response",
        "sv": "Tack för ditt svar",
        "de": "Danke für Ihre Antwort",
        "pt": "Obrigado pela resposta",
        "no": "Takk for besvarelsen din",
        "es": "Gracias por su respuesta",
        "fr": "Merci pour votre réponse"
    },
    "survey_new_notification": {
        "da": "Nyt spørgeskema tilgængelig",
        "en": "New questionnaire available",
        "sv": "Nytt frågeformulär tillgängligt",
        "de": "Neuer Fragebogen verfügbar",
        "pt": "Novo questionário disponível",
        "no": "Nytt spørreskjema tilgjengelig",
        "es": "Nuevo cuestionario disponible",
        "fr": "Nouveau questionnaire disponible"
    },
    "survey_available": {
        "da": "Nyt spørgeskema tilgængelig",
        "en": "New questionnaire available",
        "sv": "Nytt frågeformulär tillgängligt",
        "de": "Neuer Fragebogen verfügbar",
        "pt": "Novo questionário disponível",
        "no": "Nytt spørreskjema tilgjengelig",
        "es": "Nuevo cuestionario disponible",
        "fr": "Nouveau questionnaire disponible"
    },
    "survey_dismiss": {
        "da": "Afvis at besvare spørgeskemaet",
        "en": "Decline to answer questionnaire",
        "sv": "Avböja att svara på enkäten",
        "de": "Beantwortung des Fragebogens ablehnen",
        "pt": "Recusar-se a responder ao questionário",
        "no": "Avslå å svare på spørreskjemaet",
        "es": "Negarse a responder el cuestionario",
        "fr": "Refuser de répondre au questionnaire"
    },
    "survey_show": {
        "da": "Vis spørgeskema",
        "en": "Show questionnaire",
        "sv": "Visa frågeformulär",
        "de": "Fragebogen anzeigen",
        "pt": "Mostrar questionário",
        "no": "Vis spørreskjema",
        "es": "Mostrar cuestionario",
        "fr": "Afficher le questionnaire"
    },
    "survey_close_warning_header": {
        "da": "Er du sikker?",
        "en": "Are you sure?",
        "sv": "Är du säker?",
        "de": "Sind Sie sicher?",
        "pt": "Tem certeza?",
        "no": "Er du sikker?",
        "es": "¿Está seguro/a?",
        "fr": "Êtes-vous certain(e) ?"
    },
    "survey_close_warning_text": {
        "da": "Vil du afslutte inden du er færdig?",
        "en": "Do you want to quit without finishing?",
        "sv": "Vill du avsluta innan du är klar?",
        "de": "Möchten Sie aufhören, bevor Sie fertig sind?",
        "pt": "Você quer sair sem terminar?",
        "no": "Vil du avslutte før du er ferdig?",
        "es": "¿Desea salir sin terminar? ",
        "fr": "Voulez-vous quitter avant d'avoir terminé ?"
    },
    "survey_close_quit": {
        "da": "Afslut",
        "en": "Quit",
        "sv": "Avsluta",
        "de": "Beenden",
        "pt": "Sair",
        "no": "Avslutt",
        "es": "Salir ",
        "fr": "Quitter"
    },
    "survey_close_cancel": {
        "da": "Fortsæt",
        "en": "Continue",
        "sv": "Fortsätt",
        "de": "Fortsetzen",
        "pt": "Continuar",
        "no": "Fortsett",
        "es": "Continuar ",
        "fr": "Continuer"
    },
    "survey_already_answered": {
        "da": "Tak for din besvarelse",
        "en": "Thank you for your response",
        "sv": "Tack för ditt svar",
        "de": "Danke für Ihre Antwort",
        "pt": "Obrigado pela resposta",
        "no": "Takk for besvarelsen din",
        "es": "Gracias por su respuesta",
        "fr": "Merci pour votre réponse"
    },
    "survey_text_placeholder": {
        "da": "Skriv venligst her…",
        "en": "Please write here...",
        "sv": "Skriv här…",
        "de": "Bitte schreiben Sie hier…",
        "pt": "Por favor, escreva aqui...",
        "no": "Vennligst skriv her...",
        "es": "Responda aquí…",
        "fr": "Veuillez écrire ici..."
    },
    "survey_other_answer": {
        "da": "Andet",
        "en": "Other",
        "sv": "Övrigt",
        "de": "Sonstiges",
        "pt": "Outros",
        "no": "Annet",
        "es": "Otro",
        "fr": "Autres"
    },
    "decline": {
        "da": "Afvis",
        "en": "Decline",
        "sv": "Avvisa",
        "de": "Ablehnen",
        "pt": "Recusar",
        "no": "Avvis",
        "es": "Rechazar",
        "fr": "Refuser"
    },
    "allow_notifications": {
        "da": "Tillad påmindelser",
        "en": "Allow notifications",
        "sv": "Tillåt påminnelser",
        "de": "Erinnerungen zulassen",
        "pt": "Permitir notificações",
        "no": "Tillat påminnelser",
        "es": "Permitir notificaciones",
        "fr": "Autoriser les notifications"
    },
    "share_mail_patient_invitation_subject": {
        "da": "Invitation fra $NAME",
        "en": "Invitation from $NAME",
        "sv": "Inbjudan från $NAME",
        "de": "Einladung von $NAME",
        "pt": "Convite de $NAME",
        "no": "Invitasjon fra $NAME",
        "es": "Invitación de $NAME",
        "fr": "Invitation reçue de $NAME"
    },
    "share_mail_staff_invitation_subject": {
        "da": "$NAME har inviteret dig til at prøve $APP_NAME",
        "en": "$NAME has invited you to try $APP_NAME",
        "sv": "$NAME har bjudit in dig att prova $APP_NAME",
        "de": "$NAME hat Sie eingeladen, $APP_NAME auszuprobieren",
        "pt": "$NAME convidou você para experimentar $APP_NAME",
        "no": "$NAME har invitert deg til å prøve $APP_NAME",
        "es": "$NAME te ha invitado a probar $APP_NAME",
        "fr": "$NAME vous a invité à essayer $APP_NAME"
    },
    "share_mail_patient_invitation": {
        "da": "Dette er din invitation til at følge et modul fra $NAME.",
        "en": "This is an invitation from $NAME to browse through a module.",
        "sv": "Detta är din inbjudan att följa en modul från $NAME.",
        "de": "Dies ist Ihre Einladung, einem Modul von $NAME zu folgen.",
        "pt": "Este é um convite de $NAME para visitar um módulo.",
        "no": "Dette er din invitasjon til å følge en modul fra $NAME.",
        "es": "Esta es su invitación para seguir un curso de tratamiento de $NAME.",
        "fr": "Il s'agit d'une invitation de $NAME dans le but de parcourir un module."
    },
    "share_mail_code": {
        "da": "Tryk på &quot;Se modulet&quot; og få direkte adgang, eller følg guiden nedenunder.",
        "en": "Press &quot;See module&quot; to get immediate access, or follow the guide below.",
        "sv": "Tryck på &quot;Visa framsteg&quot; och få direktåtkomst, eller följ guiden nedan.",
        "de": "Klicken Sie auf &quot;Modul ansehen&quot und erhalten Sie direkten Zugriff, oder folgen Sie der Anleitung unten.",
        "pt": "Clique ou toque em &quot;Ver como funciona&quot; para obter acesso imediato, ou siga o guia abaixo.",
        "no": "Trykk på &quot;Se forløp&quot; og få direkte tilgang, eller følg veiledningen nedenfor.",
        "es": "Presione &quot;Ver progreso&quot; y obtenga acceso directo, o siga la guía a continuación.",
        "fr": "Cliquez ou appuyez sur &quot;Découvrez comment ça fonctionne&quot; pour obtenir un accès immédiat, ou suivez le manuel ci-dessous."
    },
    "share_mail_use_methods": {
        "da": "Du kan vælge at få adgang via vores mobil-app eller via vores webside:",
        "en": "You can choose to get access in our mobile app or on our website.",
        "sv": "Du kan välja åtkomst via vår mobilapp eller via vår webbplats:",
        "de": "Sie können wählen, ob Sie über unsere mobile App oder über unsere Website Zugang erhalten möchten:",
        "pt": "Você pode optar por obter acesso em nosso aplicativo móvel ou em nosso site.",
        "no": "Du kan velge å få tilgang via vår mobilapp eller via vår nettside:",
        "es": "Puede acceder a través de nuestra aplicación de móvil o vía nuestra página web: ",
        "fr": "Vous pouvez choisir d'avoir accès à notre application mobile ou à notre site web."
    },
    "share_mail_staff_invitation": {
        "da": "$NAME synes, at du skal introduceres til $APP_NAME",
        "en": "$NAME thinks you ought to hear about $APP_NAME",
        "sv": "$NAME tycker att du ska introduceras till $APP_NAME",
        "de": "$NAME ist der Meinung, dass Ihnen $APP_NAME vorgestellt werden sollte",
        "pt": "$NAME acha que você deveria conhecer o $APP_NAME",
        "no": "$NAME synes du burde bli introdusert for $APP_NAME",
        "es": "$NAME cree que deberías conocer $APP_NAME, una guía digital para pacientes.",
        "fr": "$NAME pense que vous devriez découvrir $APP_NAME"
    },
    "share_mail_staff_code_activation_period": {
        "da": "Koden er aktiv i $STAFF_SHARE_EXPIRY dage fra første login",
        "en": "The code will remain active for $STAFF_SHARE_EXPIRY days from your first login",
        "sv": "Koden är aktiv i $STAFF_SHARE_EXPIRY dagar från första inloggningen",
        "de": "Der Code ist ab der ersten Anmeldung $STAFF_SHARE_EXPIRY Tage lang aktiv",
        "pt": "O código permanecerá ativo por $STAFF_SHARE_EXPIRY dias a partir de seu primeiro login",
        "no": "Koden er aktiv i $STAFF_SHARE_EXPIRY dager fra første innlogging",
        "es": "La contraseña continuará activa los primeros $STAFF_SHARE_EXPIRY días desde el primer acceso",
        "fr": "Le code restera actif pendant $STAFF_SHARE_EXPIRY jours à partir de votre première connexion."
    },
    "share_mail_see_course": {
        "da": "Se modul",
        "en": "See module",
        "sv": "Visa process",
        "de": "Modul ansehen",
        "pt": "Ver como funciona",
        "no": "Se forløp",
        "es": "ver curso",
        "fr": "Découvrez comment ça fonctionne"
    },
    "share_mail_guide_1": {
        "da": "Hent &quot;$APP_NAME&quot; i App store eller Google Play. Eller gå til $URL",
        "en": "Download &quot;$APP_NAME&quot; from the App Store or Google Play, or visit $URL",
        "sv": "Ladda ner &quot;$APP_NAME&quot; från App Store eller Google Play. Eller gå till $URL",
        "de": "Holen Sie sich &quot;$APP_NAME&quot; im App Store oder bei Google Play. Oder gehen Sie zu $URL",
        "pt": "Faça o download de &quot;$APP_NAME&quot; na App Store ou no Google Play, ou acesse $URL",
        "no": "Hent &quot;$APP_NAME&quot; i App store eller Google Play. Eller gå til $URL",
        "es": "Descarga &quot;$APP_NAME&quot; en la tienda de aplicaciones o Google Play. O vaya a $URL",
        "fr": "Téléchargez &quot;$APP_NAME&quot ; à partir d'App Store ou de Google Play, ou bien accèdez à $URL"
    },
    "share_mail_guide_2": {
        "da": "Indtast din personlige kode og du har nu adgang",
        "en": "Input your personal code to receive access",
        "sv": "Ange din personliga kod och du har nu åtkomst",
        "de": "Geben Sie Ihren persönlichen Code ein und schon haben Sie Zugriff",
        "pt": "Insira seu código pessoal para receber acesso",
        "no": "Skriv inn din personlige kode, og du har nå tilgang",
        "es": "Introduce tu código personal y ya tienes acceso",
        "fr": "Saisissez votre code personnel pour obtenir l'accès"
    },
    "share_you_are_invited": {
        "da": "Invitation fra $NAME",
        "en": "Invitation from $NAME",
        "sv": "Inbjudan från $NAME",
        "de": "Einladung von $NAME",
        "pt": "Convite de $NAME",
        "no": "Invitasjon fra $NAME",
        "es": "Invitación de $NAME",
        "fr": "Invitation reçue de $NAME"
    },
    "share_mail_your_code": {
        "da": "Din personlige kode",
        "en": "Your personal code",
        "sv": "Din personliga kod",
        "de": "Ihr persönlicher Code",
        "pt": "Seu código pessoal",
        "no": "Din personlige kode",
        "es": "Su código personal",
        "fr": "Votre code personnel"
    },
    "share_mail_need_help": {
        "da": "Brug for hjælp?",
        "en": "Need help?",
        "sv": "Behöver du hjälp?",
        "de": "Brauchen Sie Hilfe?",
        "pt": "Precisa de ajuda?",
        "no": "Trenger du hjelp?",
        "es": "¿Necesitas ayuda?",
        "fr": "Besoin d'aide ?"
    },
    "share_mail_contact_support": {
        "da": "Skriv en mail på $URL",
        "en": "Send an email to $URL",
        "sv": "Skriv ett e-postmeddelande på $URL",
        "de": "Schreiben Sie eine E-Mail an $URL",
        "pt": "Envie um e-mail para $URL",
        "no": "Skriv en e-post på $URL",
        "es": "Escriba un correo electrónico a $URL",
        "fr": "Envoyer un courriel à $URL"
    },
    "share_mail_support_subject": {
        "da": "Support - del modul - fra email",
        "en": "Support - share module - from email",
        "sv": "Support - dela modul - från e-post",
        "de": "Support - Modul teilen - per E-Mail",
        "pt": "Suporte - compartilhar módulo - a partir de e-mail",
        "no": "Support - del modul - fra e-post",
        "es": "Soporte - programa de pieza - desde correo electrónico",
        "fr": "Assistance - partager un module - à partir d'un courriel"
    },
    "share_mail_support_body": {
        "da": "Support vedrørende kode: $CODE",
        "en": "Support regarding code: $CODE",
        "sv": "Support angående kod: $CODE",
        "de": "Support bezüglich Code: $CODE",
        "pt": "Suporte relativo ao código: $CODE",
        "no": "Support angående kode: $CODE",
        "es": "Soporte de código: $CODE",
        "fr": "Assistance concernant le code : $CODE"
    },
    "google_play_button": {
        "da": "Find Mit Forløb på Google Play",
        "en": "Find My Treatment on Google Play",
        "sv": "Hitta Min Behandling på Google Play",
        "de": "Finden Sie Meine Behandlung bei Google Play",
        "pt": "Encontre o Meu Tratamento na Google Play",
        "no": "Finn Min Behandling på Google Play",
        "es": "Descargue Mi Tratamiento en Google Play",
        "fr": "Trouver Mes Soins sur Google Play"
    },
    "app_store_button": {
        "da": "Find Mit Forløb på App Store",
        "en": "Find My Treatment on the App Store",
        "sv": "Hitta Min Behandling på App Store",
        "de": "Finden Sie Meine Behandlung im App Store",
        "pt": "Encontre o Meu Tratamento na App Store",
        "no": "Finn Min Behandling på App Store",
        "es": "Descargue Mi Tratamiento en App Store",
        "fr": "Trouver Mes Soins sur App Store"
    },
    "accessibility_app_store_logo": {
        "da": "Få Mit Forløb på App Store",
        "en": "Get My Treatment from the App Store",
        "sv": "Hämta Min Behandling på App Store",
        "de": "Holen Sie sich Meine Behandlung im App Store",
        "pt": "Obtenha o Meu Tratamento na App Store",
        "no": "Få Min Behandling på App Store",
        "fr": "Télécharger Mes Soins à partir d'App Store"
    },
    "accessibility_app_googleplay_logo": {
        "da": "Få Mit Forløb på Google Play",
        "en": "Get My Treatment from Google Play",
        "sv": "Hämta Min Behandling på Google Play",
        "de": "Holen Sie sich Meine Behandlung bei Google Play",
        "pt": "Obtenha o Meu Tratamento na Google Play",
        "no": "Få Min Behandling på Google Play",
        "fr": "Télécharger Mes Soins à partir de Google Play"
    },
    "accessibility_login_email_input": {
        "da": "Indtast e-mail her",
        "en": "Input email address here",
        "sv": "Ange e-postadress här",
        "de": "Hier E-Mail-Adresse eingeben",
        "pt": "Insira o endereço de e-mail aqui",
        "no": "Skriv inn e-post her",
        "fr": "Saisissez votre adresse électronique ici"
    },
    "accessibility_login_password_input": {
        "da": "Indtast kodeord her",
        "en": "Input password here",
        "sv": "Ange lösenord här",
        "de": "Hier Passwort eingeben",
        "pt": "Insira a senha aqui",
        "no": "Skriv inn passord her",
        "fr": "Saisissez votre mot de passe ici"
    },
    "accessibility_code_input": {
        "da": "Indtast personlig kode her",
        "en": "Input personal code here",
        "sv": "Ange personlig kod här",
        "de": "Hier persönlichen Code eingeben",
        "pt": "Insira o código pessoal aqui",
        "no": "Skriv inn personlig kode her",
        "fr": "Saisissez votre code personnel ici"
    },
    "accessibility_profile_name_input": {
        "da": "Indtast dit navn her",
        "en": "Input your name here",
        "sv": "Ange ditt namn här",
        "de": "Geben Sie hier Ihren Namen ein",
        "pt": "Insira seu nome aqui",
        "no": "Skriv inn ditt navn her",
        "fr": "Saisissez votre nom ici"
    },
    "accessibility_operation_date_input": {
        "da": "Vælg din operationsdato",
        "en": "Choose the date of your operation",
        "sv": "Välj datum för din operation",
        "de": "Wählen Sie Ihr Operationsdatum",
        "pt": "Escolha a data da sua operação",
        "no": "Velg din operasjonsdato",
        "fr": "Sélectionnez la date de votre opération"
    },
    "accessibility_subtitles": {
        "da": "Undertekster:",
        "en": "Subtitles:",
        "sv": "Undertexter:",
        "de": "Untertitel:",
        "pt": "Legendas:",
        "no": "Undertekster:",
        "fr": "Sous-titres :"
    },
    "remember_user_log_in": {
        "da": "Husk brugernavn / e-mail",
        "en": "Remember username / email address",
        "sv": "Kom ihåg användarnamn / e-post",
        "de": "Benutzername/E-Mail merken",
        "pt": "Lembrar Nome de usuário / endereço de e-mail",
        "no": "Husk brukernavn / e-post",
        "fr": "Mémoriser le nom d'utilisateur / l'adresse électronique"
    },
    "login_code_guiding_title": {
        "da": "Hvor finder jeg min personlige kode?",
        "en": "Where can I find my personal code?",
        "sv": "Var hittar jag min personliga kod?",
        "de": "Wo finde ich meinen persönlichen Code?",
        "pt": "Onde posso encontrar o meu código pessoal?",
        "no": "Hvor finner jeg min personlige kode?",
        "es": "¿Dónde puedo encontrar mi código personal?",
        "fr": "Où trouver mon code personnel ?"
    },
    "login_code_guiding_text": {
        "da": "Koden udleveres fra dit behandlingssted.\\nDu modtager koden via et fysisk papkort eller digitalt.",
        "en": "Your personal code is provided by your treatment facility.\\nYou may receive the code on a physical piece of paper or digitally.",
        "sv": "Koden får du av din vårdgivare.\\nDu får koden via ett fysiskt papperskort eller digitalt.",
        "de": "Der Code wird von Ihrer Behandlungseinrichtung ausgegeben.\\nSie erhalten den Code über eine physische Pappkarte oder digital.",
        "pt": "Seu código pessoal é fornecido pela instituição de tratamento.\\nVocê pode receber o código em um pedaço de papel físico ou digitalmente.",
        "no": "Koden utstedes fra ditt behandlingssted.\\nDu mottar koden via et fysisk pappkort eller digitalt.",
        "es": "Du får en kod från din vårdenhet.\\nDu får antingen en kod på ett kodkort eller digitalt (t.ex. per post).",
        "fr": "Votre code personnel est fourni par votre centre de soins. Vous pouvez recevoir le code en version papier ou sous forme numérique."
    },
    "login_code_guiding_text_help": {
        "da": "Har du ikke modtaget en kode?\\nKontakt dit behandlingssted.",
        "en": "Didn't receive a code?\\nContact your treatment facility.",
        "sv": "Om du inte har fått någon kod?\\nKontakta din vårdgivare.",
        "de": "Sie haben keinen Code erhalten?\\nKontaktieren Sie Ihre Behandlungseinrichtung.",
        "pt": "Não recebeu um código? \\nEntre em contato com sua instituição de tratamento.",
        "no": "Har du ikke mottatt en kode?\\nKontakt behandlingssenteret ditt.",
        "es": "¿No has recibido un código? Póngase en contacto con su centro de tratamiento.",
        "fr": "Vous n'avez pas reçu de code ? Contactez votre centre de soins."
    },
    "smart_banner_header": {
        "da": "Hent Mit Forløb® som app",
        "en": "Get the My Treatment® app",
        "sv": "Ladda ner Min Behandling® som en app",
        "de": "Laden Sie Meine Behandlung als App herunter",
        "pt": "Baixar o app Meu Tratameento®",
        "no": "Last ned Min Behandling® som app",
        "fr": "Télécharger l'application Mes Soins®"
    },
    "smart_banner_description": {
        "da": "Bliv påmindet om vigtige tidspunkter",
        "en": "Get notifications about important dates and times",
        "sv": "Bli påmind om viktiga tidpunkter",
        "de": "Lassen Sie sich an wichtige Termine erinnern",
        "pt": "Receba notificações sobre datas e horários importantes",
        "no": "Bli minnet om viktige tidspunkter",
        "fr": "Recevez des notifications relatives aux dates et heures importantes"
    },
    "smart_banner_get": {
        "da": "Hent",
        "en": "Get",
        "sv": "Hämta",
        "de": "Herunterladen",
        "pt": "Download",
        "no": "Hent",
        "fr": "Télécharger"
    },
    "date_card_operation_when": {
        "da": "Hvornår skal du opereres?",
        "en": "When is your operation?",
        "sv": "När ska du opereras?",
        "de": "Wann werden Sie operiert?",
        "pt": "Quando é sua operação?",
        "no": "Når skal du opereres?",
        "fr": "Quelle est la date de votre opération ?"
    },
    "date_card_treatment_when": {
        "da": "Hvornår skal du behandles?",
        "en": "When is your treatment?",
        "sv": "När ska du behandlas?",
        "de": "Wann werden Sie behandelt?",
        "pt": "Quando é seu tratamento?",
        "no": "Når skal du behandles?",
        "fr": "Quelle est la date de vos soins ?"
    },
    "date_card_examination_when": {
        "da": "Hvornår skal du undersøges?",
        "en": "When is your examination?",
        "sv": "När ska du undersökas?",
        "de": "Wann werden Sie untersucht?",
        "pt": "Quando é seu exame?",
        "no": "Når skal du undersøkes?",
        "fr": "Quelle est la date de votre examen ?"
    },
    "date_card_operation_info": {
        "da": "Angiv din operationsdato og bliv påmindet om vigtige tidspunkter",
        "en": "Specify the date of your operation and get notifications about important dates and times",
        "sv": "Ange ditt operationsdatum och bli påmind om viktiga tidpunkter",
        "de": "Geben Sie Ihr Operationsdatum ein und lassen Sie sich an wichtige Termine erinnern",
        "pt": "Especifique a data da sua operação e receba notificações sobre datas e horas importantes",
        "no": "Angi operasjonsdatoen din og bli påminnet om viktige tidspunkter",
        "fr": "Précisez la date de votre opération et recevez des notifications relatives aux dates et heures importantes"
    },
    "date_card_treatment_info": {
        "da": "Angiv din behandlingsdato og bliv påmindet om vigtige tidspunkter.",
        "en": "Specify the date of your treatment and get notifications about important dates and times.",
        "sv": "Ange ditt behandlingsdatum och bli påmind om viktiga tidpunkter.",
        "de": "Geben Sie Ihren Behandlungstermin ein und lassen Sie sich an wichtige Termine erinnern.",
        "pt": "Especifique a data do seu tratamento e receba notificações sobre datas e horas importantes.",
        "no": "Angi behandlingsdatoen din og bli påminnet om viktige tidspunkter.",
        "fr": "Précisez la date de vos soins et recevez des notifications relatives aux dates et heures importantes"
    },
    "date_card_examination_info": {
        "da": "Angiv din undersøgelsesdato og bliv påmindet om vigtige tidspunkter.",
        "en": "Specify the date of your examination and get notifications about important dates and times.",
        "sv": "Ange ditt undersökningsdatum och bli påmind om viktiga tidpunkter.",
        "de": "Geben Sie Ihr Untersuchungsdatum ein und lassen Sie sich an wichtige Termine erinnern.",
        "pt": "Especifique a data do seu exame e receba notificações sobre datas e horas importantes",
        "no": "Angi undersøkelsesdatoen din og bli påminnet om viktige tidspunkter.",
        "fr": "Précisez la date de votre examen et recevez des notifications relatives aux dates et heures importantes"
    },
    "date_card_unknown": {
        "da": "Jeg kender ikke datoen endnu",
        "en": "I don't know the date yet",
        "sv": "Jag vet inte datum ännu",
        "de": "Ich weiß das Datum noch nicht",
        "pt": "Ainda não sei a data",
        "no": "Jeg vet ikke datoen ennå",
        "fr": "Je ne connais pas encore la date"
    },
    "date_card_enter": {
        "da": "Angiv dato",
        "en": "Specify date",
        "sv": "Ange datum",
        "de": "Datum angeben",
        "pt": "Especificar a data",
        "no": "Angi dato",
        "fr": "Précisez la date"
    },
    "fetch_no_programs_found": {
        "da": "Modul ikke fundet",
        "en": "Module not found",
        "sv": "Modulen hittades inte",
        "de": "Modul nicht gefunden",
        "pt": "Módulo não encontrado",
        "no": "Modul ble ikke funnet",
        "fr": "Module non trouvé"
    },
    "fetch_no_translations": {
        "da": "Sprog ikke fundet i modul",
        "en": "Language not found in module",
        "sv": "Språket finns inte i modulen",
        "de": "Sprache im Modul nicht gefunden",
        "pt": "Idioma não encontrado no módulo",
        "no": "Språk ikke funnet i modul",
        "fr": "Langue non trouvée dans le module"
    },
    "fetch_general_error": {
        "da": "Fejl opstået ved indlæsning af modul",
        "en": "Error while loading module",
        "sv": "Fel vid laddning av modul",
        "de": "Beim Laden des Moduls ist ein Fehler aufgetreten",
        "pt": "Erro ao carregar o módulo",
        "no": "Det oppstod en feil under innlasting av modul",
        "fr": "Erreur survenue lors du chargement du module"
    },
    "copy_link": {
        "da": "Kopiér delingslink",
        "en": "Copy link for sharing",
        "sv": "Kopiera delningslänk",
        "de": "Teilen-Link kopieren",
        "pt": "Copiar link para compartilhar",
        "no": "Kopier delingslenke",
        "es": "Copiar enlace para compartir",
        "fr": "Copier le lien pour le partager"
    },
    "copy_link_copied": {
        "da": "Link kopieret",
        "en": "Link copied",
        "sv": "Länk kopierad",
        "de": "Link kopiert",
        "pt": "Link copiado",
        "no": "Lenke kopiert",
        "es": "Enlace copiado",
        "fr": "Lien copié"
    },
    "copy_link_copied_again": {
        "da": "Kopiér igen?",
        "en": "Copy again?",
        "sv": "Kopiera igen?",
        "de": "Nochmals kopieren?",
        "pt": "Copiar novamente?",
        "no": "Kopiere igjen?",
        "es": "¿Copiar de nuevo?",
        "fr": "Copier à nouveau ?"
    },
    "network_no_internet_connection_title": {
        "da": "Ingen Internet forbindelse",
        "en": "No internet connection",
        "sv": "Ingen internetanslutning",
        "de": "Keine Internetverbindung",
        "pt": "Sem conexão à Internet",
        "no": "Ingen internettforbindelse",
        "es": "Sin conexión a Internet",
        "fr": "Aucune connexion internet"
    },
    "network_no_internet_connection_body": {
        "da": "Der er desværre ikke nogen forbindelse til internettet.\\nGenopret forbindelsen og prøv igen.",
        "en": "Unfortunately, you are not connected to the internet.\\nReconnect to the internet and try again.",
        "sv": "Tyvärr finns det ingen anslutning till internet.\\nÅteranslut och försök igen.",
        "de": "Leider besteht keine Verbindung zum Internet.\\nStellen Sie die Verbindung wieder her und versuchen Sie es erneut.",
        "pt": "Infelizmente, você não está conectado à Internet.\\nReconecte-se à Internet e tente novamente.",
        "no": "Dessverre er det ingen tilkobling til Internett.\\nKoble til på nytt og prøv igjen.",
        "es": "Desafortunadamente, no hay conexión a Internet.\\nVuelva a conectarse y vuelva a intentarlo.",
        "fr": "Malheureusement, vous n'êtes pas connecté à Internet.\\nReconnectez-vous à Internet et réessayez."
    },
    "home_your_programs": {
        "da": "Dine moduler",
        "en": "Your modules",
        "sv": "Dina moduler",
        "de": "Ihre Module",
        "pt": "Seus módulos",
        "no": "Dine moduler",
        "es": "Tus cursos",
        "fr": "Vos modules"
    },
    "home_program_options_accessibility": {
        "da": "muligheder",
        "en": "options",
        "sv": "möjligheter",
        "de": "optionen",
        "pt": "oportunidades",
        "no": "muligheter",
        "es": "oportunidades",
        "fr": "choix"
    },
    "home_your_archived_programs": {
        "da": "Arkiverede moduler",
        "en": "Archived modules",
        "sv": "Arkiverade moduler",
        "de": "Archivierte Module",
        "pt": "Módulos arquivados",
        "no": "Arkiverte moduler",
        "es": "Cursos archivados",
        "fr": "Modules archivés"
    },
    "home_add_new_program_title": {
        "da": "Tilføj nyt modul",
        "en": "Add new module",
        "sv": "Lägg till en ny modul",
        "de": "Neues Modul hinzufügen",
        "pt": "Adicionar novo módulo",
        "no": "Legg til ny modul",
        "es": "Agregar nuevo curso",
        "fr": "Ajouter un nouveau module"
    },
    "home_add_new_program_body": {
        "da": "Indtast din personlige kode",
        "en": "Input your personal code",
        "sv": "Ange din personliga kod",
        "de": "Geben Sie Ihren persönlichen Code ein",
        "pt": "Digite o seu código pessoal",
        "no": "Skriv inn din personlige kode",
        "es": "Introduce tu código personal",
        "fr": "Saisissez votre code personnel"
    },
    "home_show_archived": {
        "da": "Se arkiverede",
        "en": "See archived",
        "sv": "Se arkiverade",
        "de": "Archivierte ansehen",
        "pt": "Ver arquivados",
        "no": "Se arkiverte",
        "es": "Ver archivado",
        "fr": "Consulter les archives"
    },
    "home_hide_archived": {
        "da": "Skjul arkiverede",
        "en": "Hide archived",
        "sv": "Dölj arkiverade",
        "de": "Archivierte ausblenden",
        "pt": "Ocultar arquivados",
        "no": "Skjul arkiverte",
        "es": "Ocultar archivado",
        "fr": "Cacher les archives"
    },
    "home_restore_program_title": {
        "da": "Tilføj modul til &quote;Dine moduler&quote;",
        "en": "Add module to &quote;Your modules&quote;",
        "sv": "Lägg till modul till &quote;Dina moduler&quote;",
        "de": "Modul hinzufügen zu &quote;Ihre Module&quote;",
        "pt": "Adicionar módulo aos &quote;Seus módulos&quote;",
        "no": "Legg modul til &quote;Dine moduler&quote;",
        "es": "Agregar curso a &quote;Tus cursos&quote;",
        "fr": "Ajouter le module à &quote;Vos modules&quote;"
    },
    "home_restore_program_body": {
        "da": "Vil du tilføje &quote;$PROGRAM_NAME&quote; til dine moduler igen?",
        "en": "Do you want to add &quote;$PROGRAM_NAME&quote; to your modules again?",
        "sv": "Vill du lägga till &quote;$PROGRAM_NAME&quote; till dina moduler igen?",
        "de": "Möchten Sie &quote;$PROGRAM_NAME&quote; wieder zu Ihren Modulen hinzufügen?",
        "pt": "Você quer adicionar novamente &quote;$PROGRAM_NAME&quote; aos seus módulos?",
        "no": "Vil du legge &quote;$PROGRAM_NAME&quote; til dine moduler igjen?",
        "es": "¿Desea volver a agregar &quote;$PROGRAM_NAME&quote; a sus cursos?",
        "fr": "Voulez-vous à nouveau ajouter &quote;$PROGRAM_NAME&quote ; à vos modules ?"
    },
    "home_archive_title": {
        "da": "Arkivér modul",
        "en": "Archive module",
        "sv": "Arkivera modul",
        "de": "Modul archivieren",
        "pt": "Arquivar módulo",
        "no": "Arkiver modul",
        "es": "Progreso del archivo",
        "fr": "Archiver le module"
    },
    "home_archive_body1": {
        "da": "Er du sikker på du vil arkivere dette modul?",
        "en": "Are you sure you want to archive this module?",
        "sv": "Är du säker på att du vill arkivera denna modul?",
        "de": "Sind Sie sicher, dass Sie dieses Modul archivieren möchten?",
        "pt": "Você tem certeza que deseja arquivar este módulo?",
        "no": "Er du sikker på at du vil arkivere denne modulen?",
        "es": "¿Está seguro de que desea archivar este programa?",
        "fr": "Êtes-vous sûr de vouloir archiver ce module?"
    },
    "home_archive_body2": {
        "da": "Du vil efterfølgende kunne gendanne modulet",
        "en": "You will be able to restore the moduleagain later",
        "sv": "Du kommer sedan att kunna återställa modulen",
        "de": "Anschließend können Sie das Modul wiederherstellen",
        "pt": "Você poderá restaurar o módulo novamentemais tarde",
        "no": "Du vil deretter kunne gjenopprette modulen",
        "es": "Posteriormente podrá restaurar el proceso.",
        "fr": "Vous pourrez restaurer le moduleultérieurement"
    },
    "action_share_title": {
        "da": "Del modul med pårørende",
        "en": "Share module with loved ones",
        "sv": "Dela modul med anhöriga",
        "de": "Modul teilen mit Angehörigen",
        "pt": "Compartilhar o módulo com entes queridos",
        "no": "Del modul med pårørende",
        "es": "Comparte el progreso con familiares",
        "fr": "Partager le module avec des proches"
    },
    "action_archive_title": {
        "da": "Arkivér modul",
        "en": "Archive module",
        "sv": "Arkivera modul",
        "de": "Modul archivieren",
        "pt": "Arquivar módulo",
        "no": "Arkiver modul",
        "es": "Progreso del archivo",
        "fr": "Archiver le module"
    },
    "home_archive_program_accept": {
        "da": "Ja, arkivér",
        "en": "Yes, archive",
        "sv": "Ja, arkivera",
        "de": "Ja, archivieren",
        "pt": "Sim, arquivar",
        "no": "Ja, arkiver",
        "es": "Sí, archivo",
        "fr": "Oui, archiver"
    },
    "home_archive_program_cancel": {
        "da": "Nej, behold",
        "en": "No, keep",
        "sv": "Nej, behåll",
        "de": "Nein, behalten",
        "pt": "Não, manter",
        "no": "Nei, behold",
        "es": "No, quédatelo",
        "fr": "Non, garder"
    },
    "home_restore_program_accept": {
        "da": "Ja, tilføj",
        "en": "Yes, add",
        "sv": "Ja, lägg till",
        "de": "Ja, hinzufügen",
        "pt": "Sim, adicionar",
        "no": "Ja, legg til",
        "es": "Si, agregar",
        "fr": "Oui, ajouter"
    },
    "home_restore_program_cancel": {
        "da": "Nej tak",
        "en": "No thanks",
        "sv": "Nej tack",
        "de": "Nein danke",
        "pt": "Não, obrigado",
        "no": "Nei takk",
        "es": "No, gracias",
        "fr": "Non merci"
    },
    "home_no_active_programs_title": {
        "da": "Du har ingen aktive moduler",
        "en": "You have no active modules",
        "sv": "Du har inga aktiva moduler",
        "de": "Sie haben keine aktiven Module",
        "pt": "Não tem módulos ativos",
        "no": "Du har ingen aktive moduler",
        "es": "No tienes cursos activos",
        "fr": "Vous n'avez aucun module actif"
    },
    "home_no_active_programs_body": {
        "da": "Tilføj et nyt eller se dine arkiverede moduler, med mulighed for at tilføje dem igen",
        "en": "Add a new one, or view your archived modules and restore the ones you want to see again",
        "sv": "Lägg till en ny eller visa dina arkiverade moduler, med möjlighet att lägga till dem igen",
        "de": "Fügen Sie ein neues hinzu oder sehen Sie sich Ihre archivierten Module an, mit der Option, sie erneut hinzuzufügen",
        "pt": "Adicione um novo módulo ou veja os seus módulos arquivados e restaure os que deseja ver novamente",
        "no": "Legg til en ny eller se de arkiverte modulene dine, med mulighet til å legge dem til igjen",
        "es": "Agregue uno nuevo o vea sus cursos archivados, con la opción de agregarlos nuevamente",
        "fr": "Ajoutez un nouveau module ou consultez vos modules archivés et restaurez ceux que vous souhaitez revoir."
    },
    "home_see_archived_programs": {
        "da": "Se arkiverede moduler",
        "en": "See archived modules",
        "sv": "Se arkiverade moduler",
        "de": "Archivierte Module ansehen",
        "pt": "Ver módulos arquivados",
        "no": "Se arkiverte moduler",
        "es": "Ver cursos archivados",
        "fr": "Consulter les modules archivés"
    },
    "home_nav_title": {
        "da": "Menu",
        "en": "Menu",
        "sv": "Meny",
        "de": "Menü",
        "pt": "Menu",
        "no": "Meny",
        "es": "Menú",
        "fr": "Menu"
    },
    "preview_status_live_header": {
        "da": "Ny version af modulet afventer godkendelse",
        "en": "A new version of this  module is pending approval",
        "sv": "Ny version av modulen väntar på godkännande",
        "de": "Neue Version des Moduls wartet auf Genehmigung",
        "pt": "Uma nova versão deste  módulo está pendente de aprovação",
        "no": "Ny versjon av modulen venter på godkjenning",
        "es": "Nueva versión del curso está pendiente de aprobación.",
        "fr": "Une nouvelle version de ce  module est en cours d'approbation."
    },
    "preview_status_live_body": {
        "da": "Klik på forhåndvisning og se den nye version. Kontakt jeres Visikon-kontaktperson for eventuelle rettelser eller godkendelse.",
        "en": "Click Preview to see the new version. To make corrections or approve the module, speak with your contact at Visikon.",
        "sv": "Klicka på förhandsgranska för att se den nya versionen. Kontakta din kontaktperson på Visikon för eventuella korrigeringar eller godkännanden.",
        "de": "Klicken Sie auf Vorschau und sehen Sie die neue Version an. Wenden Sie sich für Korrekturen oder Genehmigungen an Ihre Visikon-Kontaktperson.",
        "pt": "Clique em Preview para ver a nova versão. Para fazer correções ou aprovar o módulo, fale com seu contato na Visikon.",
        "no": "Klikk på forhåndsvisning og se den nye versjonen. Kontakt din Visikon-kontaktperson for eventuelle rettelser eller godkjenning.",
        "es": "Haga clic en vista previa y vea la nueva versión. Comuníquese con su persona de contacto de Visikon para cualquier corrección o aprobación.",
        "fr": "Cliquez sur Aperçu pour voir la nouvelle version. Pour apporter des corrections ou approuver le module, adressez-vous à votre interlocuteur au sein de Visikon."
    },
    "preview_status_preview_header": {
        "da": "Du ser en forhåndsvisning af modulet.",
        "en": "You are viewing a preview of the module.",
        "sv": "Du ser en förhandsvisning av modulen.",
        "de": "Sie sehen eine Vorschau des Moduls.",
        "pt": "Você está visualizando uma pré-visualização do módulo.",
        "no": "Du ser en forhåndsvisning av modulen.",
        "es": "Verás una vista previa del proceso.",
        "fr": "Vous consultez un aperçu du module."
    },
    "preview_status_preview_body": {
        "da": "Kontakt jeres Visikon-kontaktperson for eventuelle rettelser eller godkendelse.",
        "en": "To make corrections or approve the module, speak with your contact at Visikon.",
        "sv": "Kontakta din Visikon-kontaktperson för eventuella korrigeringar eller godkännanden.",
        "de": "Wenden Sie sich für Korrekturen oder Genehmigungen an Ihre Visikon-Kontaktperson.",
        "pt": "Para fazer correções ou aprovar o módulo, fale com seu contato na Visikon.",
        "no": "Kontakt din Visikon-kontaktperson for eventuelle rettelser eller godkjenning.",
        "es": "Comuníquese con su persona de contacto de Visikon para cualquier corrección o aprobación.",
        "fr": "Pour apporter des corrections ou approuver le module, adressez-vous à votre interlocuteur au sein de Visikon."
    },
    "preview_status_preview_link": {
        "da": "Skift tilbage til nuværende version af modulet",
        "en": "Return to the current version of the module",
        "sv": "Växla tillbaka till den aktuella versionen av modulen",
        "de": "Wechseln Sie zurück zur aktuellen Version des Moduls",
        "pt": "Voltar para a versão atual do módulo",
        "no": "Bytte tilbake til gjeldende versjon av modulen",
        "es": "Volver a la versión actual del curso",
        "fr": "Retour à la version actuelle du module"
    },
    "preview_status_live_link": {
        "da": "Forhåndvisning af ny version",
        "en": "Preview of new version",
        "sv": "Förhandsgranskning av ny version",
        "de": "Vorschau der neuen Version",
        "pt": "Pré-visualização da nova versão",
        "no": "Forhåndsvisning av ny versjon",
        "es": "Vista previa de la nueva versión",
        "fr": "Aperçu de la nouvelle version"
    },
    "preview_status_contact_link": {
        "da": "Kontakt Visikon",
        "en": "Contact Visikon",
        "sv": "Kontakta Visikon",
        "de": "Visikon kontaktieren",
        "pt": "Entre em contato com a Visikon",
        "no": "Kontakt Visikon",
        "es": "Contacto Visikon",
        "fr": "Contacter Visikon"
    },
    "contact_popup_title": {
        "da": "Brug for hjælp?",
        "en": "Need help?",
        "sv": "Behöver du hjälp?",
        "de": "Brauchen Sie Hilfe?",
        "pt": "Precisa de ajuda?",
        "no": "Trenger du hjelp?",
        "es": "¿Necesitas ayuda?",
        "fr": "Besoin d'aide ?"
    },
    "contact_popup_body": {
        "da": "Kontakt os på telefon eller email",
        "en": "Contact us by telephone or email",
        "sv": "Kontakta oss via telefon eller e-post",
        "de": "Kontaktieren Sie uns per Telefon oder E-Mail",
        "pt": "Entre em contato conosco por telefone ou e-mail",
        "no": "Kontakt oss på telefon eller e-post",
        "es": "contactanos por telefono o email",
        "fr": "Contactez-nous par téléphone ou par courriel"
    },
    "contact_popup_phone": {
        "da": "Tlf: $PHONE_NO",
        "en": "Tel: $PHONE_NO",
        "sv": "Tel: $PHONE_NO",
        "de": "Tel: $PHONE_NO",
        "pt": "Telefone: $PHONE_NO",
        "no": "Tlf.: $PHONE_NO",
        "es": "Teléfono: $PHONE_NO",
        "fr": "Tél : $PHONE_NO"
    },
    "accessibility_share_your_phone_number_input": {
        "da": "Indtast modtagers telefonnummer med landekode",
        "en": "Input the recipient's phone number, including the country code",
        "sv": "Ange mottagarens telefonnummer med landskod",
        "de": "Geben Sie die Telefonnummer des Empfängers mit Ländervorwahl ein",
        "pt": "Insira o número de telefone do destinatário, incluindo o código do país",
        "no": "Tast inn mottakerens telefonnummer med landskode",
        "fr": "Saisissez le numéro de téléphone du destinataire, y compris l'indicatif du pays."
    },
    "enter_valid_phone_number": {
        "da": "Indtast gyldigt telefonnummer",
        "en": "Input a valid phone number",
        "sv": "Ange ett giltigt telefonnummer",
        "de": "Geben Sie eine gültige Telefonnummer ein",
        "pt": "Insira um número de telefone válido",
        "no": "Tast inn gyldig telefonnummer",
        "fr": "Saisissez un numéro de téléphone valide"
    },
    "confirm_logout_title": {
        "da": "Log ud",
        "en": "Log out",
        "sv": "Logga ut",
        "de": "Ausloggen",
        "pt": "Terminar sessão",
        "no": "Logg ut",
        "es": "Cerrar sesión",
        "fr": "Déconnexion"
    },
    "confirm_logout_body1": {
        "da": "Er du sikker på du vil logge ud?",
        "en": "Are you sure you want to log out?",
        "sv": "Är du säker på att du vill logga ut?",
        "de": "Möchten Sie sich wirklich ausloggen?",
        "pt": "Tem certeza de que deseja terminar a sessão?",
        "no": "Er du sikker på at du vil logge ut?",
        "es": "¿Está seguro de que desea cerrar sesión?",
        "fr": "Êtes-vous sûr de vouloir vous déconnecter ?"
    },
    "confirm_logout_body2": {
        "da": "Du vil blive returneret til login siden",
        "en": "You will be returned to the login page",
        "sv": "Du kommer tillbaka till inloggningssidan",
        "de": "Sie werden zur Anmeldeseite zurückgeleitet",
        "pt": "Você retornará à página de login",
        "no": "Du vil bli returnert til innloggingssiden",
        "es": "Volverá a la página de inicio de sesión.",
        "fr": "Vous serez redirigé vers la page de connexion"
    },
    "confirm_logout_yes": {
        "da": "Ja, log ud",
        "en": "Yes, log out",
        "sv": "Ja, logga ut",
        "de": "Ja, ausloggen",
        "pt": "Sim, terminar sessão",
        "no": "Ja, logg ut",
        "es": "Sí, cerrar sesión",
        "fr": "Oui, se déconnecter"
    },
    "confirm_logout_no": {
        "da": "Nej, bliv",
        "en": "No, stay",
        "sv": "Nej, stanna kvar",
        "de": "Nein, bleiben",
        "pt": "Não, permanecer",
        "no": "Nei, bli",
        "es": "No quedarse",
        "fr": "Non, rester"
    },
    "self_service_redirect": {
        "da": "Vi har lavet en ny personaleside. Klik herunder for at komme videre, hvor vi hjælper dig godt i gang. Adgangen for patienter og borgere er uændret.",
        "en": "We have created a new staff page. Click below to proceed, where we will help you get started. Access for patients and citizens is unchanged.",
        "de": "Wir haben eine neue Mitarbeiterseite erstellt. Klicken Sie unten, um fortzufahren. Wir helfen Ihnen beim Einstieg. Der Zugang für Patienten und Bürger bleibt unverändert."
    },
    "self_service_redirect_title": {
        "da": "Ny personaleside",
        "en": "New staff page",
        "de": "Neue Mitarbeiterseite"
    }
};
//# sourceMappingURL=translations.js.map